import type { SvgIconComponent } from "@mui/icons-material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PhoneDisabledOutlinedIcon from "@mui/icons-material/PhoneDisabledOutlined";
import ScheduleSendOutlinedIcon from "@mui/icons-material/ScheduleSendOutlined";
import UnsubscribeOutlinedIcon from "@mui/icons-material/UnsubscribeOutlined";
import { Box, Chip } from "@mui/material";
import { useTranslate } from "react-admin";

import { type CrmConsentBadge, formatCrmDayOf, parseCrmConsent } from "../../lib/crm";

const BADGE_ICONS: Record<CrmConsentBadge["code"], SvgIconComponent> = {
  NO_EMAIL: UnsubscribeOutlinedIcon,
  NO_CALLS: PhoneDisabledOutlinedIcon,
  NO_NEWSLETTER: ScheduleSendOutlinedIcon,
  EMAIL_BOUNCED: ErrorOutlineIcon,
};

const OPT_OUT_COLORS = { color: "#8e030f", backgroundColor: "#feded8", borderColor: "#fe9b8b" };
const BOUNCE_COLORS = { color: "#8c4b02", backgroundColor: "#fef1e6", borderColor: "#fcc003" };

// Whether a lead or contact may be emailed or called, as Salesforce records
// it. No badge only means none is known.
export const CrmConsentBadges = ({ value }: { value: string }) => {
  const translate = useTranslate();
  return (
    <Box component="span" sx={{ display: "inline-flex", flexWrap: "wrap", gap: "4px" }}>
      {parseCrmConsent(value).map(badge => {
        const Icon = BADGE_ICONS[badge.code];
        const colors = badge.code === "EMAIL_BOUNCED" ? BOUNCE_COLORS : OPT_OUT_COLORS;
        const since = badge.since && formatCrmDayOf(badge.since);
        return (
          <Chip
            key={badge.code}
            size="small"
            variant="outlined"
            icon={<Icon sx={{ fontSize: 14, "&&": { color: colors.color } }} />}
            label={translate(`crm.consent.${badge.code}`, { date: since ?? "" })}
            title={badge.reason ?? undefined}
            sx={{ height: 20, fontSize: "12px", fontWeight: 600, ...colors }}
          />
        );
      })}
    </Box>
  );
};
